import Typography from "@mui/material/Typography";
import React from "react";
import "./emptyDataContainer.css";

const EmptyDataContainer = ({
  message,
  hasBackground = true,
  hasFixedHeight = true,
  ...rest
}) => {
  return (
    <div
      className={
        "empty-data-container " +
        (hasBackground ? "empty-data-container-bg " : "") +
        (hasFixedHeight ? "empty-data-container-200 " : "")
      }
      {...rest}
    >
      <Typography>{message}</Typography>
    </div>
  );
};

export default EmptyDataContainer;
